import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { filter, map, pipe } from 'rxjs';

import { Activity } from 'app/shared/features/activity-selector/models';
import { activityFeatureKey, ActivityState } from 'app/state/activities/activity.reducer';

export const selectActivityState = createFeatureSelector<ActivityState>(activityFeatureKey);

export const selectActivityList = createSelector(selectActivityState, (state) => state.activityList);

export const selectActivityListIfLoaded = pipe(
    select(selectActivityList),
    filter((list): list is Activity[] => !!list),
);

export const selectActivityByNumber = (activityNumber: number) =>
    pipe(
        selectActivityListIfLoaded,
        map((activityList) => activityList.find((activity) => activity.number === activityNumber)),
    );
